const WORDS: readonly string[] = [
  'Arc',   'Ash',   'Beam',  'Blade', 'Blaze', 'Bolt',
  'Core',  'Crest', 'Dark',  'Dart',  'Dawn',  'Drake',
  'Drift', 'Dusk',  'Edge',  'Fire',  'Flash', 'Flux',
  'Force', 'Forge', 'Frost', 'Gale',  'Glow',  'Gold',
  'Grim',  'Haze',  'Hawk',  'Hex',   'Ink',   'Iron',
  'Keen',  'Lynx',  'Mist',  'Nox',   'Nova',  'Null',
  'Orb',   'Pulse', 'Ray',   'Red',   'Rex',   'Rift',
  'Rock',  'Rune',  'Scar',  'Shade', 'Shard', 'Smoke',
  'Sol',   'Spark', 'Star',  'Steel', 'Stone', 'Storm',
  'Surge', 'Swift', 'Tide',  'Vane',  'Veil',  'Void',
  'Wave',  'Wing',  'Wolf',  'Wraith',
] as const;

export function randomName(): string {
  const i = Math.floor(Math.random() * WORDS.length);
  let j = Math.floor(Math.random() * (WORDS.length - 1));
  if (j >= i) j++;
  return `${WORDS[i]} ${WORDS[j]}`;
}
